export class archivoRoutech {
    constructor(
        public descripcion: string,
        public idRuta: number,
        public idRazonSocial: number,
        public archivo: string,
        public peso: number,
        public noviaje: number
    ){}
}